"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function usePagination(allData, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.pageSize, pageSize = _c === void 0 ? 20 : _c, _d = _b.startPage, startPage = _d === void 0 ? 1 : _d;
    var _e = react_1.useState(startPage), page = _e[0], setPage = _e[1];
    var data = react_1.useMemo(function () { return allData.slice((page - 1) * pageSize, page * pageSize); }, [
        allData,
        page,
        pageSize,
    ]);
    var pageCount = react_1.useMemo(function () { return Math.ceil(data.length / pageSize); }, [data, pageSize]);
    return { page: page, setPage: setPage, pageCount: pageCount, data: data };
}
exports.default = usePagination;
